import React, { Component } from 'react';

import { observer } from 'mobx-react';

import Loader from '../Loader';
import ErrorMessage from './ErrorMessage';
import CardTypeLogos from './CardTypeLogos';
import SecurityMetricsIcon from './SecurityMetricsIcon';
import { MONTHS_AS_OPTIONS } from './constants/months';
import { YEARS_AS_OPTIONS } from './constants/years';
import { detectCardType } from './constants/cardTypes';
import { FIELDS, REQUIRED_ICON_RENDER } from './constants/fieldsMembership';
import { ERRORS } from './constants/errors';
import membershipStore from '../../stores/membershipStore';
import { processChangeForm, loadPromotion } from '../../actions/membershipActions';
import { T } from '../../stores/textStore';

class BillingFormMembership extends Component {
	validate(fieldName) {
		const { changeForm, changeFormErrors } = membershipStore;
		changeFormErrors.delete(fieldName);			
		if (!changeForm.get(fieldName) && this.isRequired(fieldName)) {
			changeFormErrors.set(fieldName, ERRORS.REQUIRED);
		} else if (changeForm.get(fieldName) && FIELDS[fieldName].regex &&
				!FIELDS[fieldName].regex.test(changeForm.get(fieldName))) {
			changeFormErrors.set(fieldName, `Please enter a valid ${FIELDS[fieldName].label}`);
		} else if (!changeForm.get('use_stored_cc') && fieldName === 'cc_number' && 
				!changeForm.get('payment_method')) {			
			changeFormErrors.set(fieldName, ERRORS.INVALID_CCNUMBER);
		}
	}

	validateEntireForm() {
		for (let key in FIELDS) {
			this.validate(key);
		}
	}

	isFormValid() {		
		return !membershipStore.changeFormErrors.size;
	}	

	isRequired(fieldName) {
		const { changeForm } = membershipStore;			
		if (fieldName === 'cc_number' || fieldName === 'cc_holder_name' || 
				fieldName === 'cc_expiration_month' || fieldName === 'cc_expiration_year' ||
				fieldName === 'payment_method') {			
			if (changeForm.get('use_stored_cc')) {
				return false;
			}
		}
		return FIELDS[fieldName].required;	
	}

	isStoredCcUsable() {
		if (!membershipStore.storedCc) {
			return false;
		}
		const current = membershipStore.getCurrentUserSubscription();
		if (!['O-CMAS', 'O-CMMS', 'O-PMAS', 'O-PMMS'].includes(current.subscription.sku)) {
			return false;
		}
		console.log('YYYYY', current.subscription.sku);
		let now = new Date();
		let expiration = membershipStore.storedCc.ccexpiredate;
		let parts = expiration.split('/');
		let month = parseInt(parts[0]);
		let year = parseInt(parts[1])
		if (year < now.getFullYear()) {
			return false;
		}
		if (year === now.getFullYear()) {
			return month >= (now.getMonth() + 1);
		}		
		return true;
	}	

	handleChange = (event) => {
		event.preventDefault();
		const { changeForm, changeFormErrors } = membershipStore;		
		changeForm.set(event.target.name, event.target.value);			
		if (event.target.name === 'cc_number') {			
			this.handleCcNumberChange();
		}	
		if (event.target.name === 'payment_frequency') {
			membershipStore.prmotionAppliedSuccessfully.set(false);
			membershipStore.promotionErrorMessage.set(null);
			if (membershipStore.changeForm.get('payment_frequency') !== 'monthly' && 
					membershipStore.getPromotion()) {
				membershipStore.promotionsResultSet.set(null)
				membershipStore.prmotionAppliedSuccessfully.set(false);
				membershipStore.promotionErrorMessage.set(T('This promotion is only valid for monthly plans. To use this promo code, please change the plan type to "Monthly".'));
			}
			if (membershipStore.eligibleForTrial && membershipStore.changeForm.get('payment_frequency') === 'monthly') {				
				membershipStore.promoCode.set('X-M-FREE14D');
				loadPromotion();
			}			
		}
		if (changeFormErrors.get(event.target.name)) {
			this.validate(event.target.name);
		}
	}

	handleUseStoredCcChange = (event) => {		
		membershipStore.changeForm.set('use_stored_cc', event.target.checked);
	}

	handleBlur = (event) => {
		event.preventDefault();
		this.validate(event.target.name);
	}	

	handleCcNumberChange() {
		const { changeForm } = membershipStore;
		const cardType = detectCardType(changeForm.get('cc_number'));
		if (!cardType) {
			changeForm.set('payment_method', '');
			return;
		}	
		if (cardType.name === 'amex' && membershipStore.defactoCurrency.code !== 'USD') {
			changeForm.set('payment_method', '');
			return;
		}	
		changeForm.set('payment_method', cardType.paymentMethod);
	}

	handleSubmit = (event) => {
		event.preventDefault();		
		this.validateEntireForm();
		if (this.isFormValid()) {			
			processChangeForm();
		}
	}	

	renderInput(name) {
		const { changeForm, changeFormErrors, processing } = membershipStore			
		return (
			<span>
				<label>
					{this.isRequired(name) && REQUIRED_ICON_RENDER}							
					{T(FIELDS[name].label)}
				</label>
				<input 				
					type="text" 
					className={'form-control' + (changeFormErrors.get(name) ? ' is-invalid' : '')}
					name={name} 
					placeholder="" 
					value={changeForm.get(name)} 
					onChange={this.handleChange}
					onBlur={this.handleBlur}
					ref={name === 'firstname' ? this.firstnameInputRef : null}
					disabled={processing.get()}
				/>
				<ErrorMessage text={changeFormErrors.get(name)} />
			</span>
		);
	}

	renderSelect(name) {
		const { changeForm, changeFormErrors, processing } = membershipStore;
		let optionsRender = [];
		if (name === 'cc_expiration_month') {
			optionsRender.push(<option key='EMPTY' value=""></option>);
			optionsRender = optionsRender.concat(MONTHS_AS_OPTIONS);
		} else if (name === 'cc_expiration_year') {
			optionsRender.push(<option key='EMPTY' value=""></option>);
			optionsRender = optionsRender.concat(YEARS_AS_OPTIONS);		
		} else if (name === 'payment_frequency') {			
			optionsRender.push(<option key='annual' value="annual">Annual</option>);
			const current = membershipStore.getCurrentUserSubscription();
			if (current.subscription.payment_frequency !== 'annual') {
				optionsRender.push(<option key='monthly' value="monthly">Monthly</option>);
			}
		}
		return (
			<span>
				<label>
					{this.isRequired(name) && REQUIRED_ICON_RENDER}							
					{T(FIELDS[name].label)}
				</label>
				<select                   								 
					className="form-control" 
					name={name}								
					value={changeForm.get(name)}
					onChange={this.handleChange}
					onBlur={this.handleBlur}
					disabled={processing.get()}
				>
					{optionsRender}
				</select>
				<ErrorMessage text={changeFormErrors.get(name)} />		
			</span>
		);
	}	

	renderUseStoredCcSwitch() {
		if (!this.isStoredCcUsable()) {
			return null;
		}		
		return (
			<div className="col-sm-12 form-group">
				<div className="form-check">
					<input 
							type="checkbox" 
							className="form-check-input" 
							name="use_stored_cc" 
							checked={membershipStore.changeForm.get('use_stored_cc')}							
							onChange={this.handleUseStoredCcChange}							
					/>					
					<label className="form-check-label">
						{T('Use credit card on file')} ({membershipStore.storedCc.ccnumber})?
					</label>
				</div>
			</div>
		);
	}

	render() {				
		const { changeForm } = membershipStore;			
		const processing = membershipStore.processing.get();
		const useStoredCc = changeForm.get('use_stored_cc');		
		return (
			<span>				
				<form className="needs-validation" noValidate onSubmit={this.handleSubmit}>
					<div className="row">
						<div className="col-sm-12 form-group">	
							{this.renderSelect('payment_frequency')}
						</div>	
						{this.renderUseStoredCcSwitch()}					
					</div>	
					{!changeForm.get('use_stored_cc') && 
						<span>							
							<div className="row">							
								<div className="col-sm-9 form-group">
									{this.renderInput('cc_holder_name', true)}
								</div>	
								<div className="col-sm-3 form-group text-right">								
									<SecurityMetricsIcon />
								</div>
								<div className="col-sm-8 form-group">
									{this.renderInput('cc_number', true)}
								</div>	
								<div className="col-sm-4 form-group">
									{this.renderInput('security_code', true)}
								</div>							
								<div className="col-sm-12 form-group">						
									<CardTypeLogos method={changeForm.get('payment_method')} />
								</div>																			
								<div className="col-sm-6 form-group">
									{this.renderSelect('cc_expiration_month')}
								</div>	
								<div className="col-sm-6 form-group">	
									{this.renderSelect('cc_expiration_year')}
								</div>
							</div>
						</span>
					}								
					<div className="row">					
						<div className="col-sm-12 col-lg-4">																
							<button 
								type="submit" 
								className="tkc-btn btn-block tkc-btn-red" 	
								disabled={processing}																					
							>
								{T('Submit')}
							</button>	  							
						</div> 														
					</div>	
					<div className="row mt-3">					
						<div className="col-12 text-center">
							{processing ? 
								<span>
									<p>
										<Loader width='50px' />																
									</p>									
									<p>
										{T('Processing your membership plan changes. This may take a while. Please avoid refreshing your browser or navigating away from this page.')}
									</p>									
								</span>
								:
								<span><br /><br /></span>
							}																					
						</div> 														
					</div>	
					<hr className="mb-4 mt-4" />									
					<div className="row">
						<div className="col-sm-12 form-group small text-muted">										 															
							<p>
								Kabbalah Centre International, Inc.<br />
								1062 S. Robertson Blvd., Los Angeles, CA 90035, USA
							</p>																								
							<p>Merchant Outlet is USA.</p>
						</div>						
					</div>															
				</form>
			</span>
		);
	}

}

export default observer(BillingFormMembership);



// WEBPACK FOOTER //
// ./src/components/billing-form/BillingFormMembership.js